import { useMemo } from 'react';
import { useGetCmsConfigsQuery } from '../../apis/cmsApi/cms.hooks.api';
import { Order, OrderState } from '../../models';
import { useOrder } from '../useOrder';

export const useIsReviewEnabled = () => {
  const order = useOrder();
  const { data: cmsConfigs } = useGetCmsConfigsQuery(undefined);

  const isReviewEnabled = useMemo(() => {
    if (order && cmsConfigs)
      return getIsReviewAvailable(
        order,
        cmsConfigs.featureFlags.isReviewEnabled
      );
    return false;
  }, [cmsConfigs, order]);
  return {
    enabled: isReviewEnabled,
    posteMode: cmsConfigs?.featureFlags.useReviewModePoste || false,
  };
};

const getIsReviewAvailable = (
  { status, ...order }: Order,
  isServiceEnabled: boolean
) => {
  const isValidOrderState = status === OrderState.Fulfilled;
  const isFirstReview = !order.review?.rating;
  return isValidOrderState && isFirstReview && isServiceEnabled;
};
